"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Footer_component_exports = {};
__export(Footer_component_exports, {
  Footer: () => Footer
});
module.exports = __toCommonJS(Footer_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"));
const Footer = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const footerStyle = "flex justify-center flex-wrap gmui-footer px-m sm:px-xl py-m xs:py-s";
  const navStyle = "flex flex-col lg:flex-row md:items-center w-full lg:justify-between gap-y-m xl:gap-y-0";
  const copyrightStyle = "gmui-footer-copyright gmui-font-style-minor-text m-0";
  const copyrightStyleWrap = "flex justify-center";
  const Links = ({ children: children2 }) => {
    const listStyle = "flex flex-wrap justify-center gap-m list-none m-0 p-0";
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("ul", { className: listStyle, children: import_react.default.Children.map(children2, (child) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("li", { className: "gmui-font-link-standalone-small gmui-themed-font-weight-link-standalone-small px-2xs py-3xs", children: child })) });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("footer", __spreadProps(__spreadValues({ className: footerStyle }, props), { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("nav", { className: navStyle, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Links, { children }) }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: copyrightStyleWrap, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "p",
      {
        className: copyrightStyle,
        tabIndex: -1,
        children: ` \xA9 ${currentYear} GREAT MINDS PBC`
      }
    ) })
  ] }) }));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Footer
});
//# sourceMappingURL=Footer.component.js.map